import { JourneyUiDefinition, StepUiDefinition } from '../models/onboarding.types';

/**
 * Trilhas de boas-vindas por perfil (Solicitante, Aprovador, Pedido): cada etapa é um tutorial
 * da central e conclui quando o usuário termina esse tutorial (validador tutorial-concluido no
 * backend). Cadastrar uma trilha nova = mais uma entrada aqui + a definição no backend.
 */
interface TrailStep {
  tutorialKey: string;
  icon: string;
  route: string;
}

function trail(journeyKey: string, i18nKey: string, steps: TrailStep[]): JourneyUiDefinition {
  const base = `onboarding.journeys.${i18nKey}`;
  const stepDefinitions: Record<string, StepUiDefinition> = {};
  for (const step of steps) {
    const stepBase = `onboarding.tutorials.${step.tutorialKey.replaceAll('-', '_')}`;
    stepDefinitions[step.tutorialKey] = {
      titleKey: `${stepBase}.title`,
      descriptionKey: `${stepBase}.description`,
      whyKey: `${base}.why`,
      icon: step.icon,
      route: step.route,
      actionLabelKey: 'onboarding.step.open_screen',
      tutorialKey: step.tutorialKey,
    };
  }
  return {
    journeyKey,
    titleKey: `${base}.title`,
    subtitleKey: `${base}.subtitle`,
    welcome: {
      titleKey: `${base}.welcome.title`,
      leadKey: `${base}.welcome.lead`,
      benefitKeys: ['onboarding.trail.benefit_short', 'onboarding.trail.benefit_real', 'onboarding.trail.benefit_redo'],
    },
    completion: { titleKey: 'onboarding.trail.completion_title', messageKey: 'onboarding.trail.completion_message', actions: [] },
    steps: stepDefinitions,
    revalidateOn: [],
  };
}

export const REQUESTER_WELCOME_JOURNEY = trail('requester-welcome', 'requester_welcome', [
  { tutorialKey: 'create-request', icon: 'post_add', route: '/app/shipper/requests/new' },
  { tutorialKey: 'track-requests', icon: 'fact_check', route: '/app/shipper/requests' },
]);

export const APPROVER_WELCOME_JOURNEY = trail('approver-welcome', 'approver_welcome', [
  { tutorialKey: 'approve-request', icon: 'task_alt', route: '/app/shipper/requests' },
  { tutorialKey: 'convert-approved-request', icon: 'swap_horiz', route: '/app/shipper/requests' },
]);

export const ORDER_WELCOME_JOURNEY = trail('order-welcome', 'order_welcome', [
  { tutorialKey: 'track-orders', icon: 'inventory_2', route: '/app/shipper/orders' },
]);
